import classNames from 'classnames';
import { CloseOutlined } from '@ant-design/icons';
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Button, Input, Select } from 'antd';

const { Option } = Select;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  .header-left {
    display: flex;
    margin-bottom: 8px;
    align-items: center;
  }

  .label-container {
    flex-shrink: 0;
    white-space: nowrap;
    font-weight: bold;
    margin-right: 8px;
  }

  .remove-button-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    flex-grow: 1;
  }
`;

// изъятие isValid, чтобы не пробрасывалось в DOM элемент
// и не кидало warning в консоль
const StyledSelect = styled(({ isValid, ...props }) => <Select {...props} />)`
  width: auto;
  flex-shrink: 0;
  min-width: 150px;
  margin-right: 10px;
  outline: ${({ isValid }) => (isValid ? '' : 'solid red 1px')};
`;

const StyledButton = styled(Button)`
  border: 1px solid transparent;
`;

const StyledLegendContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 5px;

  .input-caption {
    margin-right: 5px;
    flex-shrink: 0;
  }
`;

const StepHeader = ({
  optional,
  label,
  event,
  events,
  first,
  removeStep,
  setEventName,
  showNotValidFields,
  enabled,
  onChangeLegendName,
  legendName = '',
  fromDashboard,
}) => {
  const [isValid, setValid] = useState(true);

  useEffect(() => {
    if (showNotValidFields) {
      setValid(!enabled || event);
    }
  }, [event, showNotValidFields, enabled]);

  useEffect(() => {
    if (!enabled && legendName.length) {
      onChangeLegendName('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, legendName]);

  const options = useMemo(() => {
    return [...events]
      .sort((a, b) => a.localeCompare(b))
      .map((e) => (
        <Option key={e} value={e}>
          {e}
        </Option>
      ));
  }, [events]);

  return (
    <StyledHeader>
      <div className="header-left">
        <div
          className={classNames('label-container', 'disable-select', {
            'funnel-optional-text': optional,
          })}
        >
          {label}
        </div>
        <StyledSelect
          showSearch
          placeholder="Select an event"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          isValid={isValid}
          dropdownMatchSelectWidth={false}
          dropdownStyle={{ width: 'auto' }}
          value={event || undefined}
          onSelect={setEventName}
          className="ant-select-border-bottom"
          getPopupContainer={(triggerNode) => triggerNode}
          virtual={false}
        >
          {options}
        </StyledSelect>
        {fromDashboard && !first && (
          <StyledLegendContainer>
            <span className="input-caption">Legend name:</span>
            <Input
              className="input"
              placeholder="User legend"
              value={legendName}
              onChange={(e) => onChangeLegendName(e.target.value)}
              maxLength={80}
            />
          </StyledLegendContainer>
        )}
      </div>
      <div className="remove-button-container">
        {first ? null : (
          <StyledButton className="square-icon-button" onClick={removeStep}>
            <CloseOutlined />
          </StyledButton>
        )}
      </div>
    </StyledHeader>
  );
};

export default StepHeader;
